import { AssignmentResponse, AssignmentStatus } from '@/types';

export const isAssignmentOverdue = (
  assignment: AssignmentResponse
): boolean => {
  if (!assignment.deadline) return false;

  const deadline = new Date(assignment.deadline);
  if (isNaN(deadline.getTime())) return false;

  const completedStatuses: AssignmentStatus[] = ['published', 'cancelled'];

  return (
    deadline.getTime() < Date.now() &&
    !completedStatuses.includes(assignment.status)
  );
};
